import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBt5vp90vKpAxVEHKpdrKQ82l4AafyDgEE",
  authDomain: "messanger-d6ae0.firebaseapp.com",
  databaseURL: "https://messanger-d6ae0.firebaseio.com",
  projectId: "messanger-d6ae0",
  storageBucket: "messanger-d6ae0.appspot.com",
  messagingSenderId: "323516990801",
  appId: "1:323516990801:web:8e7cd876c5abde57d43f70"
});

const db = firebaseApp.firestore();

export default db;
